export default __webpack_public_path__ + "static/media/cat4-2.be481893.jpg";